import React from 'react'
import { useModal } from '../../context/modalContext'
import '../../styles/Modal.css'


const Modal = ({ isOpen, onClose, onConfirm, type }) => {

  const { loading } = useModal()

  if(!isOpen) return null

  // Custom text based on modal type (cancel or confirm)
  const isCancelType = type === 'cancel'
  const confirmText = isCancelType ? 'YES, CANCEL MY APPOINTMENT' : 'YES, CONFIRM MY APPOINTMENT'
  const modalMessage = isCancelType ? 'This will cancel your appointment.' : 'This will confirm your appointment.'

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2 className='modal-heading'>ARE YOU SURE?</h2>
        <p className='modal-text'>{modalMessage}</p>
        <div className="modal-buttons">
          <button className="confirm-button" onClick={onConfirm} disabled={loading}>
            {!loading ? confirmText : (
              <div className='loader-container'>
                <div className='loader-btn'></div>
              </div>
            )}
          </button>
          <button className="cancel-button" onClick={onClose}>NO, KEEP MY APPOINTMENT</button>
        </div>
      </div>
    </div>
  )
}

export default Modal